import React from "react";
import Carousel from "./Carousel";

export default function ReactIsland(props) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          🚀 React Island Component
        </h3>
        <p className="text-gray-600">
          This is a React component embedded within an ERB template!
        </p>
      </div>
      
      <div className="space-y-6">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="font-semibold text-blue-900 mb-2">Component Info</h4>
          <p className="text-blue-800 text-sm">
            This React component is mounted using Stimulus and receives props from Rails.
          </p>
        </div>
        
        {props.current_user && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-semibold text-green-900 mb-2">User Data</h4>
            <p className="text-green-800 text-sm">
              <strong>User:</strong> {props.current_user.name || 'Guest'}
            </p>
          </div>
        )}
        
        {props.homepage_version && (
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <h4 className="font-semibold text-purple-900 mb-2">Version Info</h4>
            <p className="text-purple-800 text-sm">
              <strong>Version:</strong> {props.homepage_version}
            </p>
          </div>
        )}
        
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <h4 className="font-semibold text-gray-900 mb-2">Interactive Demo</h4>
          <button 
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-200"
            onClick={() => alert('React component is working! 🎉')}
          >
            Click Me!
          </button>
        </div>
        
        {/* Carousel Component */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-6">
          <h4 className="font-semibold text-blue-900 mb-4 text-center">🎠 Interactive Carousel</h4>
          <Carousel slides={props.carousel_slides} />
        </div>
      </div>
    </div>
  );
}
